import {moneyFormat} from './money';
import {trans, transchoice} from './translation';

export default {
  moneyFormat,
  trans,
  transchoice
};



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/filters/index.js